import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function UserMenu({ pb, setIsAuthenticated, colors, participantTag }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    pb.authStore.clear();         // Clears local PB cache
    setIsAuthenticated(false);    // Updates parent state to show AuthGate
    navigate('/');                // Kicks user to home route
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <span style={{ fontSize: '12px', color: colors.text, opacity: 0.7 }}>
        {participantTag}
      </span>
      <button 
        onClick={handleLogout} 
        style={{ 
          background: 'transparent', 
          color: colors.text, 
          border: `1px solid ${colors.border}`, 
          padding: '6px 12px', 
          borderRadius: '4px', 
          cursor: 'pointer', 
          fontSize: '12px',
          transition: 'background 0.2s ease'
        }}
        onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255, 0, 0, 0.1)'}
        onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
      >
        Logout
      </button>
    </div>
  );
}